export default __webpack_public_path__ + "static/media/space-kitty.48069b67ec1d92e43b29b90fa89fd286.jpg";